export enum THEME {
  SA = "sa",
  GA = "ga",
  CRICO = "crico",
}

export enum LOOKUP {
  REFERRED_BY = "REFERRED_BY",
  ENQUIRY_SOURCE = "ENQUIRY_SOURCE",
  ENQUIRY_SOURCE_GA = "ENQUIRY_SOURCE_GA",
  ENQUIRY_SOURCE_CRICO = "ENQUIRY_SOURCE_CRICO",
  CENTER_TYPE = "CENTER_TYPE",
  ITEM_CATEGORY = "ITEM_CATEGORY",
  MODE_OF_PAYMENT = "MODE_OF_PAYMENT",
  PRIMARY_BENEFIT_YOU_EXPECT = "PRIMARY_BENEFIT_YOU_EXPECT",
  PRIMARY_BENEFIT_YOU_EXPECT_GA = "PRIMARY_BENEFIT_YOU_EXPECT_GA",
  PRIMARY_BENEFIT_YOU_EXPECT_CRICO = "PRIMARY_BENEFIT_YOU_EXPECT_CRICO",
  REGISTRATION_TYPE = "REGISTRATION_TYPE",
  FOLLOW_UP_REMARKS = "FOLLOW_UP_REMARKS",
  LEVEL_STATUS = "LEVEL_STATUS",
  LOGIN_TYPE = "LOGIN_TYPE",
  USER_TYPE = "USER_TYPE",
  USER_TYPE_FA = "USER_TYPE_FA",
  LEAD_TYPE = "LEAD_TYPE",
  MEMBERSHIP = "MEMBERSHIP",
  CANCEL_REASON = "CANCEL_REASON",
  COURIER_NAME = "COURIER_NAME",
  MODE_OF_DISPATCH = "MODE_OF_DISPATCH",
  DISCONTINUE_REASON = "DISCONTINUE_REASON",
  PRIMARY_BENEFIT_YOU_EXPECT_US = "PRIMARY_BENEFIT_YOU_EXPECT_US",
}

export const LOGIN_TYPE = {
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  UPFRONT: "Upfront",
  FORTNIGHTLY: "Fortnightly",
};

export const TAX_TYPE = {
  GST: "GST",
  NON_GST: "Non GST",
  COMPOSITE: "Composite",
};

export const STUDENT = {
  INVOICE_ITEM_TYPE_OPTIONS: [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Fee",
      value: "Fee",
    },
    {
      label: "Loose",
      value: "Loose",
    },
    {
      label: "Kit Item",
      value: "Kit Item",
    },
    {
      label: "Competition Fee",
      value: "Competition Fee",
    },
    {
      label: "Practice Portal Fee",
      value: "Practice Portal Fee",
    },
    {
      label: "Late Fee",
      value: "Late Fee",
    },
  ],
  CERTIFICATE_STATUS: {
    BOOKED: "Booked",
    REQUISITION: "Requisition",
    APPROVED: "Approved",
    DISPATCHED: "Dispatched",
    NOT_YET_BOOKED: "Not Yet Booked",
    PARTIAL_REQUISITION: "Partial Requisition",
    RECEIVED: "Received",
    REASSESSMENT: "Reassessment",
  },
};

export const PURCHASE = {
  INTERNAL_PO_TYPE: [
    {
      label: "Training KIT",
      value: "Training KIT",
    },
    {
      label: "Free KIT",
      value: "Free KIT",
    },
    {
      label: "Replacement Item",
      value: "Replacement Item",
    },
  ],
  MONTHS: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  REDEEMED_PRODUCT_STATUS: {
    REQUISITION: "Requisition",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    DISPATCHED_TO_SH: "Dispatched to SH",
    RECEIVED_BY_SH: "Received by SH",
    DISPATCHED_TO_FRANCHISEE: "Dispatched to Franchisee",
    CANCELLED: "Cancelled",
  },

  DISPATCH_REDEEMED_PRODUCT_STATUS: [
    {
      label: "Requisition",
      value: "Requisition",
    },
    {
      label: "Approved",
      value: "Approved",
    },
    {
      label: "Rejected",
      value: "Rejected",
    },
    {
      label: "Cancelled",
      value: "Cancelled",
    },
    {
      label: "Dispatched to SH",
      value: "Dispatched to SH",
    },
    {
      label: "Received by SH",
      value: "Received by SH",
    },
    {
      label: "Dispatched to Franchisee",
      value: "Dispatched to Franchisee",
    },
  ],
  ITEM_STATUS: {
    APPROVED: "Approved",
    REJECTED: "Rejected",
    DISPATCHED: "Dispatched",
    PARTIALLY_DISPATCHED: "Partially Dispatched",
    REQUISITION: "Requisition",
    CANCELLED: "Cancelled",
  },
  PO_STATUS: [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Requisition",
      value: "Requisition",
    },
    {
      label: "Dispatched",
      value: "Dispatched",
    },
    {
      label: "Rejected",
      value: "Rejected",
    },
    {
      label: "Partially Dispatched",
      value: "Partially Dispatched",
    },
    {
      label: "Approved",
      value: "Approved",
    },
  ],
  PR_STATUS: {
    CANCELLED: "Cancelled",
    RECEIVED: "Received",
    REQUISITION: "Requisition",
  },
  PR_STATUS_OPTIONS: [
    {
      label: "Requisition",
      value: "Requisition",
    },
    {
      label: "Cancelled",
      value: "Cancelled",
    },
    {
      label: "Received",
      value: "Received",
    },
  ],
};
export const GENDER = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
  {
    label: "TG",
    value: "TG",
  },
];
export const COURSE = {
  ACRYLIC: "Acrylic",
  GCLAY: "G Clay",
};
export const PAYMENT_SETTLEMENT_STATUS = [
  {
    label: "Initiated",
    value: "Initiated",
  },
  {
    label: "Shipped",
    value: "Shipped",
  },
  {
    label: "Awaited",
    value: "Awaited",
  },
  {
    label: "Unsuccessful",
    value: "Unsuccessful",
  },
  {
    label: "Aborted",
    value: "Aborted",
  },
];
export const TAX_PERCENTAGE = {
  INDIA: 18,
  USA: 6.625,
};

export const countryList = {
  INDIA: "India",
  USA: "United States",
};